// extracted by mini-css-extract-plugin
export var blurb = "footer-module--blurb--3qpQw";
export var copyright = "footer-module--copyright--NzlVR";
export var font = "footer-module--font--X7lQW";
export var fontsm = "footer-module--fontsm--B9KeU";
export var footerNavList = "footer-module--footerNavList--cQ54n";
export var footerNavListItem = "footer-module--footerNavListItem--dvq2M";
export var footerStyle = "footer-module--footerStyle--pYd6o";
export var heading_fontsm = "footer-module--heading_fontsm--o1G2J";
export var heading_fontsmm = "footer-module--heading_fontsmm--YnBwe";
export var info = "footer-module--info--asHit";
export var links = "footer-module--links--yXqoa";
export var logos = "footer-module--logos--n0E9x";
export var royalfont_sm = "footer-module--royalfont_sm--u8XhB";